import React, { createContext, useContext, useMemo } from 'react'
import { useFeatureValue } from '@growthbook/growthbook-react'
import { growthBookInstances } from '../constants'

const GrowthBookContext = createContext(null)

export const GrowthBookProvider = ({ children }) => {
  const content = useFeatureValue('createsexfriend-content', growthBookInstances)
  const paywallTheme = useFeatureValue('createsexfriends-paywall-theme', 'default')
  const animatedPictures = useFeatureValue('createsexfriend-animated-pictures', 'AUTOMATIC')
  const steps = useFeatureValue('createsexfriend-steps', 'BASE')
  const attributeSelectionStyle = useFeatureValue('createsexfriend-attribute-selection-style', 'DEFAULT')
  const magicLink = useFeatureValue('createsexfriends-gray-magicLink', 'OFF')

  const values = useMemo(
    () => ({
      content: content || growthBookInstances,
      paywallTheme: paywallTheme || 'default',
      animatedPictures: animatedPictures || 'AUTOMATIC',
      steps: steps || 'BASE',
      attributeSelectionStyle: attributeSelectionStyle || 'DEFAULT',
      magicLink: magicLink || 'OFF',
    }),
    [content, paywallTheme, animatedPictures, steps, attributeSelectionStyle, magicLink]
  )

  return (
    <GrowthBookContext.Provider value={values}>
      {children}
    </GrowthBookContext.Provider>
  )
}

export const useGrowthBookValues = () => {
  const context = useContext(GrowthBookContext)
  if (!context) {
    throw new Error(
      'useGrowthBookValues must be used within GrowthBookProvider'
    )
  }
  return context
}
